import { motion } from 'framer-motion';
import { CreditCard, RefreshCw, Frown, Users } from 'lucide-react';

const problems = [
  {
    icon: CreditCard,
    title: 'Paying for multiple subscriptions',
    iconClass: 'icon-red',
  },
  {
    icon: RefreshCw,
    title: 'Constant context switching',
    iconClass: 'icon-orange',
  },
  {
    icon: Frown,
    title: 'Missed updates and deadlines',
    iconClass: 'icon-blue',
  },
  {
    icon: Users,
    title: 'Disconnected workflows',
    iconClass: 'icon-purple',
  },
];

export const Problem = () => {
  return (
    <section className="py-20 bg-white" data-testid="problem-section">
      <div className="container-main">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <span className="section-label section-label-orange">THE PROBLEM</span>
          <h2 className="text-3xl sm:text-4xl lg:text-[42px] font-bold text-[#1E293B] leading-tight mb-6">
            Juggling Tools Is Killing Your<br />Team's Productivity
          </h2>
          <p className="text-[#64748B] text-lg max-w-3xl mx-auto leading-relaxed">
            Every day, teams waste hours switching between project boards, chat apps, and endless 
            notifications. Tasks fall through the cracks. Messages get lost. Costs add up. And nobody 
            knows where to find the latest update.
          </p>
        </motion.div>

        {/* Problem Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto mb-12">
          {problems.map((problem, index) => (
            <motion.div
              key={problem.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="feature-card text-center"
              data-testid={`problem-card-${index}`}
            >
              <div className={`w-12 h-12 rounded-xl mx-auto mb-4 flex items-center justify-center ${problem.iconClass}`}>
                <problem.icon className="w-6 h-6" />
              </div>
              <h3 className="text-[#1E293B] font-medium text-sm leading-snug">
                {problem.title}
              </h3>
            </motion.div>
          ))}
        </div>

        {/* Solution teaser */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center text-[#64748B] text-base"
        >
          We've been there — managing projects in one app and conversations in another.{' '}
          <span className="text-[#1E293B] font-semibold">That's why we built a smarter way.</span>
        </motion.p>
      </div>
    </section>
  );
};
